import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a9762a36d471300143484a2_1788404769012_0c660079/tempmail/src/app/sign-up-login-screen/components/AuthPageClient.tsx");
